import React from 'react';
import Picky from 'react-picky';

import I18n from 'i18n-react';

import './CompaniesIdentity.css';

class CompaniesIdentity extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      companiesList: props.companiesList,
      companiesIdentityOriginal: props.companiesIdentity,
      isTouched: props.isTouched,
    };
    this.selectMultipleOption = this.selectMultipleOption.bind(this);
    this.closeDropdown = this.closeDropdown.bind(this);
    this.clearAll = this.clearAll.bind(this);
    this.scrollToElement = this.scrollToElement.bind(this);
  }

  componentWillMount() {
    let companiesIdentity = this.mountCompaniesIdentity();
    this.setState({
      companiesIdentity: companiesIdentity,
      companiesIdentityOriginal: this.props.companiesIdentity
    })
    this.props.callbackCompaniesIdentity(this.createCompaniesString(companiesIdentity));
  }

  componentDidUpdate() {
    if (this.state.companiesList.length === 0 &&
      this.props.companiesList.length > 0) {
      this.setState({
        companiesList: this.props.companiesList
      });
    };

    if (this.props.companiesIdentity !== this.state.companiesIdentityOriginal) {
      let companiesIdentity = this.mountCompaniesIdentity();
      this.setState({
        companiesIdentity: companiesIdentity,
        companiesIdentityOriginal: this.props.companiesIdentity
      })
      this.props.callbackCompaniesIdentity(this.createCompaniesString(companiesIdentity));
    };
  }

  mountCompaniesIdentity() {
    let companiesIdentityConverted = [];
    let companiesIdentity = this.props.companiesIdentity;
    if (companiesIdentity !== '-') {
      let companiesIdentitySplited = companiesIdentity !== '' ? companiesIdentity.split("-") : [];
      companiesIdentitySplited.forEach(e => {
        companiesIdentityConverted.push({
          id: e,
          name: I18n.translate('company.' + e)
        })
      });
    }
    return companiesIdentityConverted
  }

  createCompaniesString(companies) {
    const companiesListIata = companies.map(e => {
      return e.id;
    });
    return companiesListIata.length > 0 ? companiesListIata.join('-') : ''
  }

  selectMultipleOption(value) {
    this.setState({ companiesIdentity: value });
    this.props.callbackCompaniesIdentity(this.createCompaniesString(value));
    if (value.length === 0) {
      this.props.onTouched(false);
    }
    else {
      this.props.onTouched(true);
    }
  }

  closeDropdown() {
    this.dropDownField.click();
  }

  clearAll() {
    const { companiesList } = this.state;
    const { companiesIdentity } = this.props;

    if (companiesList.length === companiesIdentity.length) {
      this.selectAll.click();
    }
    else {
      this.props.onTouched(false);
    }
  }

  scrollToElement() {
    const rect = this.dropDownField.getBoundingClientRect(),
      scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    let elementPosTop = rect.top + scrollTop;
    window.scroll({
      top: elementPosTop - 250,
      behavior: 'smooth'
    });
  }

  render() {
    const { companiesIdentity, isTouched } = this.state;

    return (
      <div
        className="filter-wrapper ta-form-group"
        ref={field => this.dropDownField = field}
        onClick={this.scrollToElement}>
        <label className="control-label">{I18n.translate('home.label.filterBy')}</label>
        <Picky
          value={companiesIdentity}
          options={this.state.companiesList}
          onChange={this.selectMultipleOption}
          open={false}
          valueKey="id"
          labelKey="name"
          placeholder={!isTouched ? 'Todas as companhias' : 'Nenhuma selecionada'}
          multiple={true}
          includeSelectAll={true}
          selectAllText="Todas as companhias"
          allSelectedPlaceholder="Todas as companhias"
          manySelectedPlaceholder="%s Selecionadas"
          includeFilter={false}
          dropdownHeight={295}
          numberDisplayed={5}
          className={`ta-dropdown -select ${companiesIdentity.length >= 0 ? 'selected' : ''} ${isTouched ? 'has-value' : ''}`}
          render={({
            style,
            isSelected,
            item,
            selectValue,
            labelKey,
            valueKey,
            multiple
          }) => {
            const selectedItems = [];
            selectedItems.push(item);
            return (
              <li
                style={style}
                className={`ta-checkbox ${isSelected ? 'selected' : ''}`}
                key={item[valueKey]}
                onClick={() => selectValue(item)}
              >
                <input type="checkbox" checked={isSelected} readOnly />
                <span>{item[labelKey]}</span>
              </li>
            );
          }}
          renderSelectAll={({
            filtered,
            tabIndex,
            allSelected,
            toggleSelectAll,
            multiple,
          }) => {
            // Don't show if single select or items have been filtered.
            if (multiple && !filtered) {
              return (
                <div className="selectAll">
                  <div
                    tabIndex={tabIndex}
                    role="option"
                    aria-selected="true"
                    data-selectall="true"
                    className={allSelected ? 'option selected' : 'option'}
                    onClick={toggleSelectAll}
                    onKeyPress={toggleSelectAll}
                    ref={all => this.selectAll = all}
                  >
                    <span>{I18n.translate("home.label.selectAll")}</span>
                  </div>
                  <i className="ta-icon icon-close close-btn" onClick={() => this.closeDropdown()}></i>
                </div>
              );
            }
          }}
        />
        <i className="ta-icon icon-close" onClick={() => this.clearAll()}></i>
      </div>
    );
  }
}

export default CompaniesIdentity;


// WEBPACK FOOTER //
// ./src/components/searchBox/companiesIdentity/CompaniesIdentity.jsx